import { type FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { StatsGrid } from './StatsGrid';
import { useTramiteStatusSummary } from './useTramiteStatusSummary';
import { SubtramiteList } from './SubtramiteList';
import { getSubtramiteRoutePath } from '@/common/utils/subtramiteNavigation';
import { useGroupedSubtramites } from './useGroupedSubtramites';
import { GroupedSubtramiteList } from './GroupedSubtramiteList';

export interface TramiteStatusSummaryFilteredProps {
  tramite: any;
  showOnlyStarted?: boolean;
}

const TramiteStatusSummaryFiltered: FC<TramiteStatusSummaryFilteredProps> = ({
  tramite,
  showOnlyStarted = true
}) => {
  const {
    stats,
    subtramites
  } = useTramiteStatusSummary(tramite);

  // Obtener subtrámites agrupados por categoría
  const groups = useGroupedSubtramites(tramite, showOnlyStarted);

  // Filtrar subtrámites para mostrar solo los iniciados (fallback para vista sin agrupar)
  const filteredSubtramites = showOnlyStarted
    ? subtramites.filter(subtramite => subtramite.status !== 'pendiente')
    : subtramites;

  // Recalcular estadísticas globales desde los grupos
  const filteredStats = showOnlyStarted ? {
    "en-proceso": groups.reduce((sum, g) => sum + g.stats['en-proceso'], 0),
    "pendiente": 0, // No mostramos pendientes en el modal
    "finalizado": groups.reduce((sum, g) => sum + g.stats['finalizado'], 0),
  } : stats;

  return (
    <>
      {/* Resumen compacto en una fila con estadísticas filtradas */}
      <StatsGrid stats={filteredStats} hideStats={["pendiente"]} />

      {/* Lista de subtrámites agrupados por categoría optimizada para modal */}
      <GroupedSubtramiteList
        groups={groups}
        tramite={tramite}
        variant='compact'
      />
    </>
  );
};

TramiteStatusSummaryFiltered.displayName = 'TramiteStatusSummaryFiltered';

export default TramiteStatusSummaryFiltered;